import React from "react";

const UserReportTable = ({ data }) => {
  const getAlertTotals = (data = []) =>
    data.reduce(
      (acc, item) => {
        acc.processed_alerts += item.processed_alerts || 0;
        acc.assigned_alerts += item.assigned_alerts || 0;
        acc.reassigned_alerts += item.reassigned_alerts || 0;
        acc.closed_alerts += item.closed_alerts || 0;
        acc.percentage_of_closure_processed +=
          item.percentage_of_closure_processed || 0;
        acc.percentage_of_closure_total +=
          item.percentage_of_closure_total || 0;
        return acc;
      },
      {
        processed_alerts: 0,
        assigned_alerts: 0,
        reassigned_alerts: 0,
        closed_alerts: 0,
        percentage_of_closure_processed: 0,
        percentage_of_closure_total: 0,
      }
    );
  return (
    <div>
      <div>
        <div className="mt-4 col-12 ">
          <p className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
            USER WISE ALERT STATISTICS
          </p>
          <p className="border-top border-1 border-black opacity-75"></p>
        </div>
        <div className="border border-1 border-black p-2">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr className="f3 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 mx-2 text-muted first-data-row fw-light">
                <th rowSpan="2">User Name</th>
                <th rowSpan="2">Processed Alerts</th>
                <th rowSpan="2">Assigned Alerts</th>
                <th rowSpan="2">Reassigned Alerts</th>
                <th rowSpan="2">Closed Alerts</th>
                <th colSpan="2" className="text-center">
                  Percentage of Closure
                </th>
              </tr>
              <tr className="f2 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 mx-2 text-muted first-data-row fw-light">
                <th>Out of Processed Alerts</th>
                <th>Out of Total Alerts</th>
              </tr>
            </thead>

            <tbody>
              {data?.user_performance_data?.map((item, ind) => {
                return (
                  <tr
                    className="f2 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 mx-2 text-muted first-data-row fw-light"
                    key={ind}
                  >
                    <td>{item?.user_name}</td>
                    <td className="text-start">{item?.processed_alerts}</td>
                    <td className="text-start">{item?.assigned_alerts}</td>
                    <td className="text-start">{item?.reassigned_alerts}</td>
                    <td className="text-start">{item?.closed_alerts}</td>
                    <td className="text-start">
                      {item?.percentage_of_closure_processed}%
                    </td>
                    <td className="text-start">
                      {item?.percentage_of_closure_total}%
                    </td>
                  </tr>
                );
              })}
            </tbody>

            <tfoot>
              <tr className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mx-2 text-muted first-data-row fw-light">
                <td>Total</td>
                <td className="text-start">
                  {data?.total_summary?.processed_alerts}
                </td>
                <td className="text-start">
                  {data?.total_summary?.assigned_alerts}
                </td>
                <td className="text-start">
                  {data?.total_summary?.reassigned_alerts}
                </td>
                <td className="text-start">
                  {data?.total_summary?.closed_alerts}
                </td>
                <td className="text-start">
                  {data?.total_summary?.percentage_of_closure_processed}%
                </td>
                <td className="text-start">
                  {data?.total_summary?.percentage_of_closure_total}%
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        {/* FOOT NOTE */}
        <div className="mt-2 f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mx-2 text-muted first-data-row fw-light">
          <strong>Note:</strong> Processed Alerts = Assigned + Reassigned +
          Closed Alerts
        </div>
      </div>

      {data?.user_performance_data?.map((item, ind) => {
        let total = getAlertTotals(item?.alert_types);
        return (
          <div key={ind}>
            <div className="mt-4 col-12 ">
              <p className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mx-2">
                USER BREAKUP - {item?.user_name}
              </p>
              <p className="border-top border-1 border-black opacity-75"></p>
            </div>

            <div className="border border-1 border-black p-2">
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr className="f3 fs-sm-12 fs-md-12 fs-lg-12 fs-xl-12 fs-xxl-12 mx-2 text-muted first-data-row fw-light">
                    <th rowSpan="2">Name</th>
                    <th rowSpan="2">Processed Alerts</th>
                    <th rowSpan="2">Assigned Alerts</th>
                    <th rowSpan="2">Reassigned Alerts</th>
                    <th rowSpan="2">Closed Alerts</th>
                    <th colSpan="2" className="text-center">
                      Percentage of Closure
                    </th>
                  </tr>
                  <tr className="f2 fs-sm-12 fs-md-12 fs-lg-12 fs-xl-12 fs-xxl-12 mx-2 text-muted first-data-row fw-light">
                    <th>Out of Processed Alerts</th>
                    <th>Out of Total Alerts</th>
                  </tr>
                </thead>

                <tbody>
                  {item?.alert_types?.map((row, index) => {
                    return (
                      <tr
                        key={index}
                        className="f2 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-14 mx-2 text-muted first-data-row fw-light"
                      >
                        <td>{row?.alert_type_name}</td>
                        <td className="text-start">{row?.processed_alerts}</td>
                        <td className="text-start">{row?.assigned_alerts}</td>
                        <td className="text-start">{row?.reassigned_alerts}</td>
                        <td className="text-start">{row?.closed_alerts}</td>
                        <td className="text-start">
                          {row?.percentage_of_closure_processed}%
                        </td>
                        <td className="text-start">
                          {row?.percentage_of_closure_total}%
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

                <tfoot>
                  <tr className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mx-2 text-muted first-data-row fw-light">
                    <td>Total</td>
                    <td className="text-start">{total?.processed_alerts}</td>
                    <td className="text-start">{total?.assigned_alerts}</td>
                    <td className="text-start">{total?.reassigned_alerts}</td>
                    <td className="text-start">{total?.closed_alerts}</td>
                    <td className="text-start">
                      {total?.percentage_of_closure_processed}%
                    </td>
                    <td className="text-start">
                      {total?.percentage_of_closure_total}%
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <div className="mt-2 f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mx-2 text-muted first-data-row fw-light">
              <strong>Note:</strong> Processed Alerts = Assigned + Reassigned +
              Closed Alerts
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserReportTable;
